/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__ClassInputs */

const de__field__class = /** @type {(inputs: _Field__ClassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art`)
};

/**

* @param {_Field__ClassInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field__class = /** @type {((inputs?: _Field__ClassInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__ClassInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field__class(inputs)
});